import { DefaultButton, Text, Icon, Modal } from "@fluentui/react";
import "./Popup.css"; 
import CrossIcon from "../../assets/Icons/svg/crossIcon";

export default function Popup({
  isOpen,
  title,
  iconName,
  contentTitle,
  content,
  buttons = [],
  onClose,
  customContent,
  showCloseButton = true,
  width = "auto",
  minHeight = "175px",
  backgroundColor = "linear-gradient(90deg, #ECF0F9 0%, #EFECF9 100%)",
}) {
  const modalStyles = {
    root: {
      background: "rgba(0, 0, 0, 0.5)",
    },
    main: {
      borderRadius: "12px",
      background: backgroundColor,
      width: width,
      minHeight: minHeight,
    },
  };
  if (!isOpen) return null;

  return (
    <>
      <Modal
        isOpen={true}
        onDismiss={() => {}}
        styles={modalStyles}
        isBlocking={false}
      >
        <div className="popup-overlay" style={{ background: backgroundColor }}>
          <div className="popup-header">
            <Text className="popup-title">{title}</Text>
            {showCloseButton && (
              <div className="closeIcon" onClick={onClose}>
                <CrossIcon width="10px" height="10px" />
              </div>
            )}
          </div>
          <div className="popup-container">
            {customContent ? (
              customContent
            ) : (
              <div className="popup-content">
                <div className="popup-content-container">
                  <div className="popup-content-icon">
                    {iconName}
                  </div>
                  <Text className="popup-content-title">{contentTitle}</Text>
                </div>
                <Text className="popup-content-text">{content}</Text>
              </div>
            )}
            
          </div>
        </div>
    </Modal>
    </>
  );
} 